import { render, staticRenderFns } from "./StrPop.vue?vue&type=template&id=8e08f53a&lang=pug&"
import script from "./StrPop.vue?vue&type=script&lang=js&"
export * from "./StrPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports